// Formatting shared by the Benefits page, the claim modal and the ticket list.
// unit 'usd' = dollars, 'coins' = Rain.gg coins.
export function fmtWager(unit, n) {
  const v = Number(n) || 0;
  const s = v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return unit === 'coins' ? `${s} 🪙` : `$${s}`;
}

export function fmtReward(unit, n) {
  const v = Number(n) || 0;
  return unit === 'coins' ? `${v.toLocaleString()} 🪙` : `$${v.toLocaleString()}`;
}

export function fmtDate(ms) {
  return new Date(ms).toLocaleDateString([], { month: 'short', day: 'numeric' });
}

export function fmtDateTime(ms) {
  return new Date(ms).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}
